export default {
      id: "close-usage",
      viewBox: "0 0 31 31",
      url: __webpack_public_path__ + "img/icons.svg#close",
      toString: function () {
        return this.url;
      }
    }